<div class="survey">
    <app-icon
      class="survey__close mb-2"
      icon="times"
      size="lg"
      title="close"
      (click)="closeDialog()">
    </app-icon>

    <iframe [src]="src" class="survey__frame"></iframe>
</div>
